import { Component, input } from '@angular/core';

import { LandingText } from '../landing.types';
import { LandingGlow } from './landing-glow.component';
import { RevealOnScrollDirective } from './reveal-on-scroll.directive';

@Component({
    selector: 'app-landing-info',
    standalone: true,
    imports: [LandingGlow, RevealOnScrollDirective],
    templateUrl: './landing-info.component.html',
    styleUrl: './landing-info.component.scss'
})
export class LandingInfo {
    readonly text = input.required<LandingText>();
}
